module.exports = __webpack_public_path__ + "img/9788961702584.11ba77a2.jpg";